import { RelationPairs } from '@backstage/plugin-catalog-graph';

export const RELATION_BUILD_DEPENDS_ON = 'buildDependsOn';
export const RELATION_BUILD_DEPENDENCY_OF = 'buildDependencyOf';
export const RELATION_DEPLOY_DEPENDS_ON = 'deployDependsOn';
export const RELATION_DEPLOY_DEPENDENCY_OF = 'deployDependencyOf';
export const RELATION_RUNTIME_DEPENDS_ON = 'runtimeDependsOn';
export const RELATION_RUNTIME_DEPENDENCY_OF = 'runtimeDependencyOf';

export const softwareRelations: RelationPairs = [
  [RELATION_BUILD_DEPENDS_ON, RELATION_BUILD_DEPENDENCY_OF],
  [RELATION_DEPLOY_DEPENDS_ON, RELATION_DEPLOY_DEPENDENCY_OF],
  [RELATION_RUNTIME_DEPENDS_ON, RELATION_RUNTIME_DEPENDENCY_OF],
];
